<script lang="ts">
	import { Languages } from '@lucide/svelte';
	import * as DropdownMenu from '../shadcn/components/ui/dropdown-menu';
	import Button from '../shadcn/components/ui/button/button.svelte';
	import { locales, type Locale } from '../../locales/data';
	import { changeLocale } from '../utils.svelte';
	import { page } from '$app/state';
	import LanguageSelectorItem from './LanguageSelectorItem.svelte';

	let { onChange }: { onChange?: (locale: Locale) => void } = $props();

	const onSelect = (locale: Locale) => {
		onChange?.(locale);
		changeLocale(page.route.id, locale, page.params, page.url.search, page.url.hash);
	};
</script>

<DropdownMenu.Root>
	<DropdownMenu.Trigger>
		{#snippet child({ props })}
			<Button {...props} variant="tonal" size="sm" class="text-slate-400">
				<Languages />
				{page.data.locale.toLocaleUpperCase(page.data.locale)}
			</Button>
		{/snippet}
	</DropdownMenu.Trigger>

	<DropdownMenu.Content class="w-fit min-w-0" align="start">
		<DropdownMenu.Group class="flex flex-col gap-1">
			{#each locales as locale}
				<DropdownMenu.Item variant="ghost3" onSelect={() => onSelect(locale)}>
					<div class="flex items-center justify-between gap-4">
						<LanguageSelectorItem {locale} />
					</div>
				</DropdownMenu.Item>
			{/each}
		</DropdownMenu.Group>
	</DropdownMenu.Content>
</DropdownMenu.Root>
